import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GetbyorderidComponent } from './getbyorderid/getbyorderid.component';
import { MandoobsstatmentComponent } from './mandoobsstatment/mandoobsstatment.component';
import { MandoobStatment } from './mandoobstatment.model';
import { MandoobtransComponent } from './mandoobtrans/mandoobtrans.component';
import { OrdersMandoobPrivateComponent } from './orders-mandoob-private/orders-mandoob-private.component';
import { OrdersbycategoryComponent } from './ordersbycategory/ordersbycategory.component';
import { OrdersbyproductComponent } from './ordersbyproduct/ordersbyproduct.component';
import { OrdersbysubcategoryComponent } from './ordersbysubcategory/ordersbysubcategory.component';
import { OrdersbyuserComponent } from './ordersbyuser/ordersbyuser.component';
import { OrdersdirectchargedComponent } from './ordersdirectcharged/ordersdirectcharged.component';
import { OrdersreportsComponent } from './ordersreports/ordersreports.component';
import { ProductcardsreportComponent } from './productcardsreport/productcardsreport.component';
import { ProfitsComponent } from './profits/profits.component';
import { PyticordercardsComponent } from './pyticordercards/pyticordercards.component';
import { UserbymandoobtransComponent } from './userbymandoobtrans/userbymandoobtrans.component';
import { UsertransComponent } from './usertrans/usertrans.component';
import { UsertransallComponent } from './usertransall/usertransall.component';
import { DepositsusertransComponent } from './depositsusertrans/depositsusertrans.component';

const routes: Routes = [
  { path: "allByDate", component: OrdersreportsComponent },
  { path: "mandoobStatment", component: MandoobsstatmentComponent },
  { path: "ordersbycategorystatment", component: OrdersbycategoryComponent },
  { path: "ordersbysubcategorystatment", component: OrdersbysubcategoryComponent },
  { path: "ordersbyproductstatment", component: OrdersbyproductComponent },
  { path: "ordersmandoobprivatestatment", component: OrdersMandoobPrivateComponent },
  { path: "ordersbydirectcharged", component: OrdersdirectchargedComponent },
  { path: "ordersbyuser", component: OrdersbyuserComponent },
  { path: "usertrans", component: UsertransComponent },
  { path: "orderbyid", component: GetbyorderidComponent },
  { path: "profits", component: ProfitsComponent },
  { path: "productcardsreport", component: ProductcardsreportComponent },
  { path: "usertransall", component: UsertransallComponent },
  { path: "pyticorderscard", component: PyticordercardsComponent },
  { path: "mandoobtrans", component: MandoobtransComponent },
  { path: "userbymandoobtrans", component: UserbymandoobtransComponent },
  { path: "usertransdeposits", component: DepositsusertransComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReportsRoutingModule { }
